<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>The Pinch of the Game</span></h1>
<p class="P_Normal__And__Left_Indent">By <span style=" font-size: 0.93em;">CHARLEY DESCOTEAUX</span></p>
<p class="P_Normal">Jeffrey Overton, unemployed IT professional turned poker player, pushes his luck once too often and runs afoul of the host of an illegal card club. The man sent to escort Jeffrey to a “meeting” about his supernatural winning streak arrives at Jeffrey’s crappy North Portland apartment, lock-picking tools in hand and a charm to block Jeffrey’s magick.</p>
<p class="P_Normal">Head muscle for said host, Mike Wells, is a Daisy from Daisyville. He isn’t a witch. What he lacks in magickal talent he makes up for in brawn, so he doesn’t expect the guy he’s after to overpower him. But once Mike renders Jeffrey helpless, he’d rather seduce him than bring him in.</p>
<p class="P_Normal">Jeffrey and Michael ditch the “meeting” and end up hunting some of the same people they ran from, trying to get Jeffrey back into his own body. And that’s only part of the adventure. The pair travel halfway across the country on the quietest road trip in history and find missing people, empire-building witches, and maybe even the families they’d both thought lost to them.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?66f9d59a